/**
 * 商品閲覧履歴・いいね管理
 * ローカルストレージを使用してユーザーごとのデータを保存
 */

const ProductHistory = {
  // ローカルストレージのキー
  RECENTLY_VIEWED_KEY: 'anitem_recently_viewed',
  LIKED_PRODUCTS_KEY: 'anitem_liked_products',
  MAX_ITEMS: 20, // 最大保存数

  /**
   * 最近見た商品を保存
   * @param {Object} product - 商品情報
   */
  addRecentlyViewed: function(product) {
    if (!product || !product.handle) return;

    let items = this.getRecentlyViewed();

    // 既に存在する場合は削除（先頭に移動するため）
    items = items.filter(item => item.handle !== product.handle);

    // 先頭に追加
    items.unshift({
      handle: product.handle,
      id: product.id,
      title: product.title,
      price: product.price,
      image: product.image,
      url: product.url,
      timestamp: Date.now()
    });

    // 最大数を超えたら古いものを削除
    if (items.length > this.MAX_ITEMS) {
      items = items.slice(0, this.MAX_ITEMS);
    }

    localStorage.setItem(this.RECENTLY_VIEWED_KEY, JSON.stringify(items));
  },

  /**
   * 最近見た商品を取得
   * @param {number} limit - 取得数（省略時は全件）
   * @returns {Array} 商品リスト
   */
  getRecentlyViewed: function(limit) {
    try {
      const items = JSON.parse(localStorage.getItem(this.RECENTLY_VIEWED_KEY)) || [];
      return limit ? items.slice(0, limit) : items;
    } catch (e) {
      return [];
    }
  },

  /**
   * いいねした商品を追加
   * @param {Object} product - 商品情報
   */
  addLikedProduct: function(product) {
    if (!product || !product.handle) return;

    let items = this.getLikedProducts();

    // 既に存在する場合は追加しない
    if (items.some(item => item.handle === product.handle)) {
      return false;
    }

    // 先頭に追加
    items.unshift({
      handle: product.handle,
      id: product.id,
      title: product.title,
      price: product.price,
      image: product.image,
      url: product.url,
      timestamp: Date.now()
    });

    // 最大数を超えたら古いものを削除
    if (items.length > this.MAX_ITEMS) {
      items = items.slice(0, this.MAX_ITEMS);
    }

    localStorage.setItem(this.LIKED_PRODUCTS_KEY, JSON.stringify(items));
    return true;
  },

  /**
   * いいねした商品を削除
   * @param {string} handle - 商品ハンドル
   */
  removeLikedProduct: function(handle) {
    let items = this.getLikedProducts();
    items = items.filter(item => item.handle !== handle);
    localStorage.setItem(this.LIKED_PRODUCTS_KEY, JSON.stringify(items));
  },

  /**
   * いいねしているかチェック
   * @param {string} handle - 商品ハンドル
   * @returns {boolean}
   */
  isLiked: function(handle) {
    const items = this.getLikedProducts();
    return items.some(item => item.handle === handle);
  },

  /**
   * いいねをトグル
   * @param {Object} product - 商品情報
   * @returns {boolean} いいね後の状態
   */
  toggleLike: function(product) {
    if (this.isLiked(product.handle)) {
      this.removeLikedProduct(product.handle);
      return false;
    } else {
      this.addLikedProduct(product);
      return true;
    }
  },

  /**
   * いいねした商品を取得
   * @param {number} limit - 取得数（省略時は全件）
   * @returns {Array} 商品リスト
   */
  getLikedProducts: function(limit) {
    try {
      const items = JSON.parse(localStorage.getItem(this.LIKED_PRODUCTS_KEY)) || [];
      return limit ? items.slice(0, limit) : items;
    } catch (e) {
      return [];
    }
  },

  /**
   * 全データをクリア
   */
  clearAll: function() {
    localStorage.removeItem(this.RECENTLY_VIEWED_KEY);
    localStorage.removeItem(this.LIKED_PRODUCTS_KEY);
  }
};

// グローバルに公開
window.ProductHistory = ProductHistory;
